import { fetchAction } from 'src/redux/actions';

import { WatchPrefs } from '../types';
import urls from '../urls';

import { FetchRepositorySubscriptions } from './constants';

// eslint-disable-next-line import/no-default-export
export default (
  repositoryFullSlug: string,
  updatedSubscriptionSettings?: WatchPrefs
) => {
  if (updatedSubscriptionSettings) {
    return fetchAction(FetchRepositorySubscriptions, {
      url: urls.xhr.watchPrefs(repositoryFullSlug),
      fetchOptions: {
        body: JSON.stringify(updatedSubscriptionSettings),
        method: 'POST',
      },
    });
  }

  return fetchAction(FetchRepositorySubscriptions, {
    url: urls.xhr.watchPrefs(repositoryFullSlug),
  });
};
